<template>
  <div>
    <vs-popup :title="$t('WriteAnswer')" :active.sync="showModal">
      <form>
        <vs-textarea
          v-model="SuggestionsContent"
          name="Description"
          :label="$t('TextCriticOrSuggestion')"
          rows="3"
          disabled
        />
        <vs-textarea
          v-model="model.answer"
          name="Description"
          :label="$t('Answer')"
          rows="3"
        />
        <span class="text-danger text-sm" v-show="showError">
          "{{ $t("PleaseEnterDescription") }}."</span
        >
        <vs-button
          type="filled"
          class="float-right mb-4"
          @click.prevent="submitForm"
          >{{ $t("Save") }}</vs-button
        >
      </form>
    </vs-popup>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "",
  props: {
    show: { default: false },
    SuggestionsId: "",
    SuggestionsContent: "",
  },
  data() {
    return {
      model: {},
      showError: false,
    };
  },
  computed: {
    showModal: {
      get: function () {
        return this.show;
      },
      set: function () {
        this.$emit("close");
      },
    },
  },
  methods: {
    ...mapActions({
      ConfirmSuggestionsAnswer: "forum/ConfirmSuggestionsAnswer",
    }),
    submitForm() {
      if (this.model.answer != "") {
        this.model.id = this.SuggestionsId;
        this.ConfirmSuggestionsAnswer(this.model).then(() => {
          this.$swal({
            position: "center-center",
            type: "success",
            text: "توضیحات مورد نظر با موفقیت ثبت شد!",
            showConfirmButton: false,
            timer: 2000,
          });

          this.$emit("finish");
        });
      } else {
        this.showError = true;
      }
    },
  },
};
</script>
